import React from 'react'

const CustomPrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block", background: `url(https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STFSR/public/Images/prev-arrow.png) no-repeat center center`, backgroundSize: 'contain' }}
        onClick={onClick}
      />
    );
  }

export default CustomPrevArrow;
